import React from "react";
import { Link } from "react-router-dom";
import { track } from "@vercel/analytics";

const CreateTournamentButton = () => {
  return (
    <Link
      to="/create-tournament"
      className="btn-brand"
      onClick={() =>
        track("create_tournament_click", {
          location: "create_tournament_button",
        })
      }
    >
      Run a tournament
    </Link>
  );
};

export default CreateTournamentButton;
